import React from 'react';
import { useTranslation } from 'react-i18next';
import './ScreenShare.css';

export const ScreenShare: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="screenshare-section">
      <div className="screenshare-container">
        <div className="screenshare-content">
          <span className="screenshare-label">{t('screenShare.label')}</span>
          <h2 className="screenshare-title">{t('screenShare.title')}</h2>
          <p className="screenshare-subtitle">{t('screenShare.subtitle')}</p>

          <div className="screenshare-steps">
            <div className="screenshare-step">
              <div className="step-number">1</div>
              <div className="step-text">
                <h4>{t('screenShare.step1Title')}</h4>
                <p>{t('screenShare.step1Text')}</p>
              </div>
            </div>
            <div className="screenshare-step">
              <div className="step-number">2</div>
              <div className="step-text">
                <h4>{t('screenShare.step2Title')}</h4>
                <p>{t('screenShare.step2Text')}</p>
              </div>
            </div>
            <div className="screenshare-step">
              <div className="step-number">3</div>
              <div className="step-text">
                <h4>{t('screenShare.step3Title')}</h4>
                <p>{t('screenShare.step3Text')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="screenshare-visual">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="mock-header">{t('screenShare.mock.header')}</div>
              <div className="mock-canvas">
                <div className="mock-app-bg">
                  <div className="mock-button">{t('screenShare.mock.settings')}</div>
                  <div className="mock-button">{t('screenShare.mock.photos')}</div>
                  <div className="mock-button highlight-target">{t('screenShare.mock.messages')}</div>
                  <div className="mock-button">{t('screenShare.mock.calendar')}</div>
                </div>
                {/* Coordinates are percentages of the canvas box (viewBox 0-100,
                    preserveAspectRatio="none") so the circle stays locked onto the
                    Calendar button regardless of the phone's aspect ratio. */}
                <svg className="draw-overlay" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <ellipse cx="73" cy="23" rx="15" ry="8" stroke="#E84C3D" strokeWidth="1.5" fill="none" strokeDasharray="2.5,1.5" className="draw-circle" />
                  <path d="M 30 42 Q 48 34 63 26" stroke="#E84C3D" strokeWidth="1.5" fill="none" strokeLinecap="round" className="draw-arrow-line" />
                  <polygon points="64.5,24.5 60.5,29.5 65.5,28.5" fill="#E84C3D" className="draw-arrow-head" />
                </svg>
                <div className="draw-label">{t('screenShare.tapHere')}</div>
              </div>
              <div className="mock-toolbar">
                <span className="tool-dot tool-red"></span>
                <span className="tool-dot tool-blue"></span>
                <span className="tool-pencil">✏️</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
